import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/observable';
import { User } from '../../models/user.model';
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Client } from '../models/client.model';
import {server} from './constants'


export const BASE_USER:User = {
  userid: undefined, firstname:'', lastname:'', roles:[], clientid:0, defaultpickupid:0};

export const BASE_CLIENT:Client = {cname: "No Client Selected", address: "", city: "", state: "", zip: "", qbid: "0", clientid: "0"};

@Injectable()
export class AuthService {
  private httpAddress = server;

  private subject = new BehaviorSubject<User>(BASE_USER);
  private csubject = new BehaviorSubject<Client>(BASE_CLIENT);
 
  user$: Observable<User> = this.subject.asObservable()
  client$: Observable<Client> = this.csubject.asObservable()

  // returns false if !!user.userid lookup
  isLoggedIn$: Observable<boolean> = this.user$.map(user => !!user.userid);

  isLoggedOut$: Observable<boolean> = this.isLoggedIn$.map(isLoggedIn => !isLoggedIn);

  constructor(private http:HttpClient, private router : Router) {   }

  async getUserClientPromise2() {
    // get the client and user and return
    return await this.getUser2()
    .then(user => {
      if(user.clientid > 0) {
        this.subject.next(user);
        this.getClient2(user.clientid)
        .then(client => {
          this.csubject.next(client);
          const userClient = {user, client};
          return userClient
        })
      }else if (localStorage.getItem('selectedId')){
        const clientId = localStorage.getItem('selectedId')
        this.subject.next(user);
        this.getClient2(clientId)
        .then(client => {
          this.csubject.next(client);
          const userClient = {user, client};
          return userClient
        })

      }else {
        this.csubject.next(BASE_CLIENT);
        this.subject.next(user);
        const client = this.csubject.value
        const userClient = {user, client};
        console.log(userClient)
        return userClient

      }

    })
    .catch(err => console.log(err))

  }

  getUser2(): Promise<any> {
    return this.http.get(this.httpAddress + 'api/getuser')
    .toPromise()
    .then(user => user)
    .catch(err => {
      console.log(err)
      this.router.navigateByUrl('/signin')
      return {message: "unAuthorized"}
    })
    
  }

  getClient2(clientid): Promise<any> {
    return this.http.get(this.httpAddress + 'api/clients/selected/' + clientid)
    .toPromise()
    .then(client => client[0])
    .catch(err => {
      console.log(err)
      this.router.navigateByUrl('/')
      return {message: "unAuthorized"}
    })

  }

  onLogin(email, password  ) {
     const body = {email: email, password: password};
     // code to send login request
     return this.http.post<User>(this.httpAddress +'api/login', body)
        .shareReplay()
        .do((user) => {
          // return user infor and put in this.subject.next
          this.subject.next(user);
 ////         //run getUser to return userCleint
          this.router.navigateByUrl('/');
        })
   }

   onLogOut() {
    return this.http.get(this.httpAddress + 'api/logout')
    .toPromise()
    .then((result) => result)
    .catch(err => {      
      this.getUserClientPromise2()
      .then(() => {
        console.log(err)
        this.router.navigateByUrl('/')
        return {message: "unAuthorized"}

      })
      
    })

   }
}
  



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts